import { connect } from "react-redux";
import IncentiveSlab from './IncentiveSlab'
import { bindActionCreators } from "redux";
import {createIncentiveSlab} from "../../../services/redux/Valet/IncentiveSlap/action";

const mapStateToProps = (state) => ({
    incentiveSlabRes : state.CreateIncentiveSlab.incentiveSlabRes,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        createIncentiveSlab,
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(IncentiveSlab);